import { createReducer } from 'redux-act';
import { fetchEventsJSONSuccess } from "modules/actions";

export interface IRace {
	id: number;
	type: 'q1' | 'q2' | 'final';
	status: 'scheduled' | 'active' | 'complete';
	start: string;
	end: string;
}

export interface IEvent {
	id: number;
	name: string;
	circuit: string;
	status: 'scheduled' | 'active' | 'complete';
	start: string;
	end: string;
	races: IRace[];
	displayed_name: string;
	short_name: string;
	position: number;
	weather?: {
		airtemp: number;
		weather_condition: string;
	}
}

const defaultState: IEvent[] = [];

export const events = createReducer<typeof defaultState>({}, defaultState)
	.on(fetchEventsJSONSuccess, (_state, payload) => payload)
;
